var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"t-link",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.onClick}},[_c('app-logo-anim',{staticClass:"c-main-logo--over"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }